const styles = theme => ({
  container: {
    ...theme.container,
    maxWidth: '1320px', // Constrain the overall width
    margin: '0 auto', // Center the container
    overflow: 'hidden', // Prevent the quote from spilling out
    minHeight: '100vh',
  },
  priceGuide: {
    display: 'grid',
    gridTemplateColumns: '1fr 500px', // Left side grows, right side is fixed at 300px
    gap: '20px',
    height: '100%', // Adjust based on your layout
    margin: '5px 0 20px 0',
    // transition: 'grid-template-columns 0.3s ease-in-out',
    position: 'relative',
  },
  leftSide: {
    display: 'flex',
    flexDirection: 'column',
    // gap: '20px',
    overflow: 'hidden', // Prevent overflow issues
  },
  servicesSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  productsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  filters: {
    display: 'flex',
    backgroundColor: '#f9f9f9',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    gap: '10px',
    overflowX: 'auto', // Enable horizontal scrolling for the filters
    whiteSpace: 'nowrap', // Ensure filters stay in a single row
    maxWidth: '100%', // Prevent filters from expanding beyond the container
  },
  filter: {
    minWidth: '110px',
    flexGrow: 1,
  },
  table: {
    backgroundColor: '#fff',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    flex: 1,
    overflowY: 'auto', // Enable vertical scrolling for the table
    // maxHeight: '800px',
  },
  currencyFilterContainer: {
    padding: '2px 0 15px 0',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '25px',
  },
  currencyFilter: {
    minWidth: '230px',
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F9F9F9',
    padding: '20px',
  },
  intro: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    gap: '10px',
  },
  introText: {
    '& p': {
      fontSize: '1em',
      color: '#414141',
      margin: '0px',
    },
  },
  topBarSelects: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '20px',
  },
  topBarSelect: {
    width: '200px',
  },
  drawer: {
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '4px',
    // transition: 'transform 0.35s ease-in-out',
    overflowY: 'auto',
  },
  searchBar: {
    width: '230px',
    marginLeft: 'auto',
  },
  drawerToggle: {
    position: 'absolute',
    top: '0',
    right: '0',
    backgroundColor: '#f2f2f2',
    border: 'none',
    width: 'auto',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    zIndex: 1000,
    transition: 'background-color 0.05 ease-in-out',
    '&:hover': {
      backgroundColor: '#d6d6d6 !important',
    },
  },
  rightSide: {
    position: 'relative',
  },
  sectionHeaderWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    '& h3': {
      fontSize: '18px',
    },
  },
  mobileOnly: {
    display: 'none',
  },
  '@media (max-width: 1060px)': {
    priceGuide: {
      display: 'block',
    },
    drawerToggle: {
      display: 'none',
    },
    mobileOnly: {
      display: 'block',
      '& p': {
        fontStyle: 'italic',
        color: '#8a8484',
        fontWeight: 'bolder',
        fontSize: '13px',
      },
    },
  },
  tabSwitcher: {
    borderBottom: '1px solid #e9e9e9',
    '&:first-child': {
      borderTopLeftRadius: '20px',
    },
    '&:nth-child(2)': {
      borderTopRightRadius: '20px',
    },
  },
  tabs: {
    backgroundColor: '#EAEAEA',
    display: 'inline-block',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    '&:first-child': {
      borderTopLeftRadius: '20px',
    },
    '&:nth-child(2)': {
      borderTopRightRadius: '20px',
    },
  },
  tabButton: {
    color: '#404040',
    border: 'none',
    padding: '10px 20px',
    fontSize: '1.1em',
    backgroundColor: '#EAEAEA',
    fontWeight: 'bold',
    // marginLeft: '10px',
    cursor: 'pointer',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
  },
  activeTab: {
    backgroundColor: theme.qlikGreen,
    color: '#FFFFFF',
  },
  btnsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    gap: '10px',
  },
  clearAllButton: {
    border: '2px solid #f44336',
    borderRadius: '30px',
    padding: '0px 18px',
    fontSize: '1em',
    lineHeight: '1em',
    color: '#f44336',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'all .25s ease-in-out',
    backgroundColor: 'transparent',
    height: '40px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f44336',
      color: '#FFFFFF',
    },
  },
  btnCTAWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '5px',
    '& span': {
      color: 'rgb(93, 93, 93)',
      fontSize: '13px',
      fontStyle: 'italic',
    },
  },
  warning: {
    color: '#ff0f0f',
    fontStyle: 'italic',
  },
  btnOutline: theme.btnOutline,
  btnFilled: theme.btnFilled,
  '@media (max-width: 760px)': {
    // table: {
    //   maxHeight: '400px',
    // },
    intro: {
      display: 'block',
    },
    btnsWrapper: {
      marginTop: '10px',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
    },
    currencyFilterContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  loaderIcon: {
    width: '50px',
    height: '50px',
    border: '4px solid #ccc',
    borderTop: '4px solid #009845', // Qlik green for loader color
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  errorPopup: {
    zIndex: '9999',
    backgroundColor: '#404040',
    position: 'absolute',
    top: '20%',
    left: 'calc(50% - 250px)',
    width: '500px',
    textAlign: 'center',
    padding: '20px',
    color: 'white',
  },

});

export default styles;

